import React, { FunctionComponent } from 'react'
import { Box, Grid, Typography, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  textAlign: 'center',
}))

export const FontsTest: FunctionComponent = () => {
  return (
    <Box sx={{ pt: 4 }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Item>
            <Typography variant='caption'>
              {'Headline Typeface | H3 | Playfair Display Bold'}
            </Typography>
            <Typography variant='h3'>
              {`
                Playfair Display Bold 
                abcdefghijklmnopqrstuvwxyz
                ABCDEFGHIJKLMNOPQRSTUVWXYZ
                1234567890
                `}
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Typography variant='caption'>
              {'Paragraph Typeface | Nunito Sans Regular | body1'}
            </Typography>
            <Typography variant='body1'>
              {`
                Nunito Sans Regular
                abcdefghijklmnopqrstuvwxyz
                ABCDEFGHIJKLMNOPQRSTUVWXYZ
                1234567890
                `}
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Typography variant='caption'>
              {'Emphasized Paragraph Typeface | Nunito Sans Bold | body2'}
            </Typography>
            <Typography variant='body2'>
              {`
                Nunito Sans Bold
                abcdefghijklmnopqrstuvwxyz
                ABCDEFGHIJKLMNOPQRSTUVWXYZ
                1234567890
                `}
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Typography variant='caption'>
              {'Subheadline Typeface | Raleway Bold | subtitle1'}
            </Typography>
            <Typography variant='subtitle1'>
              {`
                Raleway Bold
                abcdefghijklmnopqrstuvwxyz
                ABCDEFGHIJKLMNOPQRSTUVWXYZ
                1234567890
                `}
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Typography variant='caption'>
              {'Caption/Hyperlink Typeface | Nunito Sans Italic | caption'}
            </Typography>
            <Typography variant='caption'>
              {`
                Nunito Sans Italic
                abcdefghijklmnopqrstuvwxyz
                ABCDEFGHIJKLMNOPQRSTUVWXYZ
                1234567890
                `}
            </Typography>
          </Item>
        </Grid>
      </Grid>
    </Box>
  )
}
